<template>
  <div>
  
  
 <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
   <h4  slot="header" class="title">
     Controller's Current Details
    </h4>
 <card v-if="model.is_company==1" class="form-horizontal">

	   <div style="padding:10px 0px 20px 30px;">
		  <h5 v-if="coy.company_type!=7"  slot="header" class="title">
			 Shareholder Is A Company
		  </h5>
		  
		  <h5 v-if="coy.company_type==7"  slot="header" class="title">
			 Member Is A Company
		  </h5>
  
		  <br/><strong>Company Name:</strong> {{shareholder_company.company_name}}
		  <br/><strong>Company Registration Number:</strong> {{shareholder_company.company_reg_num}}
		  <br/><strong>Company Address:</strong> {{shareholder_company.address}}
	 	</div>
  </card>
 <card class="form-horizontal">
   <div style="padding:10px 0px 20px 30px;">
   
     <h5 v-if="model.is_company==1" slot="header" class="title">
     Company Representative
    </h5>
    
    
  <br/><strong>First Name:</strong> {{person.first_name}}
  <br/><strong>Last Name:</strong> {{person.last_name}}
   <br/><br/> 
    
  <br/><strong>ID No:</strong> {{person.gov_id}}
  <br/><strong>Citizenship:</strong> {{getCitizenship(person.citizenship)}}
  <br/><strong>Nationality:</strong> {{getCountry(person.nationality)}}
  
  <br/><br/> 
   <br/><strong>Address:</strong> {{person.address_1}}
   <br/><strong>Email:</strong> {{person.email}}
   <br/><strong>Contact No:</strong> {{person.contact_num}}
   </div>
   
   <div>
     <p-button  type="info"  @click="editPerson(person.id)" >
									
									Edit Person
	 </p-button>
	</div>
	
   
  </card>
       
    <h4  slot="header" class="title">
    Latest Form Submission
    </h4>
 <card class="form-horizontal">
 	  <div style="padding:10px 0px 20px 30px;">
 	  					<div v-if="compliance">
 	  					
 	  							<div style="margin-top:10px;"><strong>Notification Sent</strong></div>
								 <div v-if="compliance.notification_status == 1"> 
									{{compliance.last_notification_date_str}}
								</div>
								<div v-else> - </div>
								
								
						
								   <div style="margin-top:25px;"><strong>Submission Date</strong></div>
								   <div v-if="compliance.submission_status == 1"> 
											{{compliance.submission_date_str}}
									</div>
									<div v-else> - </div>
										
							<div v-if="compliance.form_obj" style="">
	
									
									<div style="margin-top:50px;"><strong>Are you a registrable controller</strong></div>
									<div v-if="compliance.form_obj.im_controller==1">
											Yes 
									</div>
									<div v-else>Declared he/she isn't the controller</div>
									
									
									<div style="margin-top:25px;"><strong> Do you know or have reasonable grounds to believe that any other person is a registrable controller or is likely to have that knowledge? </strong></div>
									<div v-if="compliance.form_obj.know_controller==1">
											Know Of Another Controller
									</div>
									<div v-else>No</div>
									
									
									
									<!-- start corporate controller -->
									<div v-if="model.is_company==1">
									
									<div style="margin-top:25px;"><strong>New Entity Name</strong></div>
									<div v-if="compliance.form_obj.entity_name">
											 {{compliance.form_obj.entity_name}}
									</div>
									<div v-else>-</div>
									
									
									<div style="margin-top:25px;"><strong>New Unique Entity Number</strong></div>
									<div v-if="compliance.form_obj.company_reg_num">
											 {{compliance.form_obj.company_reg_num}}
									</div>
									<div v-else>-</div>
									
									
									<div style="margin-top:25px;"><strong>New Registered Address</strong></div>
									<div v-if="compliance.form_obj.entity_address">
											 {{compliance.form_obj.entity_address}}
									</div>
									<div v-else>-</div>
									
									
									<div style="margin-top:25px;"><strong>Your legal form</strong></div>
									<div v-if="compliance.form_obj.legal_form">
											 {{compliance.form_obj.legal_form}}
									</div>
									<div v-else>-</div>
									
									
									
									<div style="margin-top:25px;"><strong>The jurisdiction where, and statute under which, you are formed or incorporated</strong></div>
									<div v-if="compliance.form_obj.jurisdiction">
											 {{compliance.form_obj.jurisdiction}}
									</div>
									<div v-else>-</div>
									
									
									<div style="margin-top:25px;"><strong>The name of the corporate entity register of the jurisdiction in which you are formed or incorporated (if applicable)</strong></div>
									<div v-if="compliance.form_obj.corporate_entity_register">
											 {{compliance.form_obj.corporate_entity_register}}
									</div>
									<div v-else>-</div>
									
									
									<div style="margin-top:25px;"><strong>The identification number or registration number on the corporate entity register of the jurisdiction where you are formed or incorporated (if applicable)</strong></div>
									<div v-if="compliance.form_obj.corporate_entity_register_id_num">
											 {{compliance.form_obj.corporate_entity_register_id_num}}
									</div>
									<div v-else>-</div>
									
									
									
									</div>
									<!-- end corporate controller -->
									
									
									<!-- start individual controller -->
									<div v-if="model.is_company!=1">
									
									<div style="margin-top:25px;"><strong>New First Name</strong></div>
									<div v-if="compliance.form_obj.first_name">
											 {{compliance.form_obj.first_name}}
									</div>
									<div v-else>-</div>
									
									
									<div style="margin-top:25px;"><strong>New Last Name</strong></div>
									<div v-if="compliance.form_obj.last_name">
											{{compliance.form_obj.last_name}}
									</div>
									<div v-else>-</div>
									
									
									<div style="margin-top:25px;"><strong>New Alias</strong></div>
									<div v-if="compliance.form_obj.alias">
											{{compliance.form_obj.alias}}
									</div>
									<div v-else>-</div>
									
									
									<div style="margin-top:25px;"><strong>New Address</strong></div>
									<div v-if="compliance.form_obj.address">
										 {{compliance.form_obj.address}}
									</div>
									<div v-else>-</div>
									
									
									<div style="margin-top:25px;"><strong>New Nationality</strong></div>
									<div v-if="compliance.form_obj.nationality">
										 {{compliance.form_obj.nationality}}
									</div>
									<div v-else>-</div>
									
									
									
									<div style="margin-top:25px;"><strong>New Government ID Number</strong></div>
									<div v-if="compliance.form_obj.gov_id">
											 {{compliance.form_obj.gov_id}}
									</div>
									<div v-else>-</div>
									
									
									<div style="margin-top:25px;"><strong>New Date Of Birth</strong></div>
									<div v-if="compliance.form_obj.dob">
										{{compliance.form_obj.dob}}
									</div>
									<div v-else>-</div>
									
									</div>
									<!-- end individual controller -->
									
									
									
									<div style="margin-top:25px;"><strong> Date On Which You Became An Individual Controller (* Leave empty if you do not know the exact date)</strong></div>
									<div v-if="compliance.form_obj.date_controller">
											{{compliance.form_obj.date_controller}}
									</div>
									<div v-else>-</div>
									
									
									<div style="margin-top:25px;"><strong>Information Of Another Known Controller</strong></div>
									<div v-if="compliance.form_obj.know_controller_info">
											{{compliance.form_obj.know_controller_info}}
									</div>
									<div v-else>Not Applicable</div>
								</div>
								</div>
								<div v-else><strong>Email Notification Not Sent</strong></div>
								
 
 	  </div><!-- end padding container -->
 </card>     
 
 <div style="margin-top:100px"></div>


        <div class="card" style="margin-bottom:50px">
          <div class="card-header">
              <h5 class="title">Compliance Submissions</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="allSubmissions" :row-class-name="scRowClassName">
     
                 <el-table-column label="Submission Date" property="submission_date"></el-table-column>
                 <el-table-column label="Last Notification Date" property="last_notification_date"></el-table-column>
                 
                 
                 <el-table-column label="Action" property="mode" >
						<template slot-scope="scope">
	
							
							  <p-button  type="info"  @click="viewComplianceForm(scope.row.id)" >
									
									View
							</p-button>
	
							
						</template>
					</el-table-column>
					
					
                 
            </el-table>

          </div>
        </div>
 
 
  <div style="margin-top:100px;">     
    <h4  slot="header" class="title">
     Add New Compliance Update
    </h4>
   </div>       
   <card>
   		  <div  class="col-sm-3">
      		 <fg-input label="This Update Is By" >
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Where This Update Is From"
                             v-model="compliance_update.update_by">
                    <el-option v-for="option in selects.compliance_update_by"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
          </div>
          
          
          
   		  <div  class="col-sm-3">
      		 <fg-input label="Update Type" >
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select The Type Of Update"
                             v-model="compliance_update.update_type">
                    <el-option v-for="option in selects.compliance_update_type"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
          </div>
          
           <div  class="col-sm-3">
      		 <fg-input label="New Compliance Status" >
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="compliance_update.update_compliance_status">
                    <el-option v-for="option in selects.update_compliance_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
          </div>
                
        
        
         <div class="col-sm-3">
       	 <fg-input label="Date Of Update" >
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="compliance_update.date_of_update" type="date" placeholder="Select Date"
              	name ="deadline"
              	:error="getError('date_of_update')"
                v-validate="modelValidations.date_of_update" 
              >
              </el-date-picker>
            </fg-input>
      	</div>
            

        	
        	<div class="col-sm-7">    
                 <fg-input type="text"
                  name="remarks"
				  label="Remarks"                  
                  v-model="compliance_update.remarks">
       			 </fg-input>
            </div>
    
		<p-button  type="info" @click.prevent="submitAddNewComplianceUpdateForm">Add New Update</p-button>
   </card>
   
   
   
   <!-- start  -->



<div style="margin-top:100px"></div>


        <div class="card" style="margin-bottom:50px">
          <div class="card-header">
              <h5 class="title">Compliance Updates</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="complianceUpdatesTable" :row-class-name="scRowClassName">
               <el-table-column label="Update By" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.update_by==1">Corp Sec</span>
           				 <span v-if="scope.row.update_by==2">Clients</span>
          			</template>
                </el-table-column>
                
                <el-table-column label="Update Type" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.update_type==1">Send Compliance Email</span>
           				 <span v-if="scope.row.update_type==2">Update From Client</span>
           				  <span v-if="scope.row.update_type==3">Corp Sec Updated ACRA</span>
          			</template>
                </el-table-column>
                
                <el-table-column label="Compliance Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.update_compliance_status==1">Complete</span>
           				 <span v-if="scope.row.update_compliance_status==2">Incomplete</span>
          			</template>
                </el-table-column>
    
     
                 <el-table-column label="Remarks" property="remarks"></el-table-column>
                 <el-table-column label="Date Of Update" property="date_of_update_str"></el-table-column>
                 
                 
                 <el-table-column label="Action" property="mode" >
						<template slot-scope="scope">
	
							 <p-button  type="danger"  @click="deleteComplianceUpdate(scope.row.id)" >
									
									Delete
							</p-button>
							
							  <p-button  type="info"  @click="viewComplianceUpdate(scope.row.id)" >
									
									View
							</p-button>
	
							
						</template>
					</el-table-column>
					
					
                 
            </el-table>

          </div>
        </div>


<!-- end certs -->


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {CommonService} from 'src/services/common.service'
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
        this.initPage();

          
    },
    
     
    data () {
      return {
        coy:[],
    	eid: this.$route.params.eid,
    	shid: this.$route.params.shid,
    	complianceUpdatesTable: [],
    	person:[],
    	compliance:[],
    	allSubmissions:[],
    	shareholder_company:[],
        model: {
          first_name: '',
          last_name: '',
          address_1: '',
          status: 1,
          is_contact_person: 2,
          date_appt: '',
          position:'Director',
          nationality:'',
          gov_id:'',
          email:'',
          contact_num:'',
          eid: this.$route.params.eid

        },
        compliance_update:{
        	remarks:'',
        	update_by:1,
        	update_type:3,
        	update_compliance_status: 1,
        	date_of_update:'',
        
        },
        modelValidations: {
          date_of_update: {
            required: true
          },
         
          
        },
        
        selects: {
          officer_status: [
            {value: 1, label: 'Active'},
            {value: 2, label: 'Resigned'},
		   ],
		  is_contact:[
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ],
		   compliance_update_by:[
		   	 {value: 1, label: 'Corp Sec'},
             {value: 2, label: 'Client'},
		   
		   ],
		   compliance_update_type:[
		   	 {value: 1, label: 'Send Compliance Email'},
             {value: 2, label: 'Update From/For Client'},
             {value: 3, label: 'Corp Sec Updated ACRA'},
		   
		   ],
		    update_compliance_status:[
		   	 {value: 1, label: 'Complete'},
             {value: 2, label: 'Incomplete'},
		   
		   ]    
        },
      }
    },
    methods:{
     initPage(){
     
     	let uri = this.$base_url+'/api/v1/entities/get/compliance_updates/'+ this.$route.params.shid+"/"
     		+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				
				this.model = response.data.shareholder;
				if(response.data.shareholder.is_company == 1){
					this.shareholder_company = response.data.shareholder.shareholder_company;
					this.person = response.data.shareholder.shareholder_company.person;
				}
				else{
					this.person = response.data.shareholder.person;
				}
				this.coy = response.data.entity_info;
				this.complianceUpdatesTable = response.data.compliance_updates;
				this.compliance = response.data.compliance_form;
				this.allSubmissions = response.data.all_compliance_forms;
			    			
			})
     
     },
     scRowClassName({ row }){
    		if(row.status == 4){
    			return "table-success";
    		}
    		else if(row.status == 5){
    			return "cs-strikethrough";
    		}
    	
      },
      getCitizenship(code){
      		if(code){
      			return CommonService.getCitizen(code);
      		}
      },
      getCountry(code){
      		if(code){
      			return CommonService.getCountry(code);
      		}
      },
      goToCertTask(row){
      	this.$router.push( '/edit-task/'+row.task_id+'/entity/'+this.$route.params.eid)
      },
      goToCert(row){
      	this.$router.push( '/view-share-cert/'+row.id+'/entity/'+this.$route.params.eid)
      },
      goToCreateTaskDetails(){
       		this.$router.push( '/create-task-details/'+ this.$route.params.eid+"/sc/"+this.$route.params.shid +"/0" + "/"+this.$route.params.type)
       },
       goToResoBuilderShareCert(){
       		this.$router.push( '/resolution-builder/0/entity/'+this.$route.params.eid)  
       },
       editPerson(person_id){
       	 this.$router.push( '/create-person/'+person_id);
       	
       },
     goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      viewComplianceUpdate(cuid){
      	this.$router.push( '/view-compliance-update/'+cuid)  
      },
      viewComplianceForm(cuid){
      	this.$router.push( '/view-compliance-form/'+cuid + '/'+this.$route.params.shid)  
      },
      deleteComplianceUpdate(cuid){
      		const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'This compliance update will be deleted.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, delete it!',
            buttonsStyling: false
          }).then(function () {
             const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/entities/post/delete_compliance_update/'+cuid+"/"+vm.shid+'/'+vm.eid;
     	 	 ApiService.post(uri).then(response => {
				swal({
				  title: 'Deleted!',
				  text: 'The update has been deleted.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					vm.initPage();
				
				})
				//end swal
            })
         
            
          })
      
      
      
      },
      submitAddNewComplianceUpdateForm() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		 swal({
						  title: 'Oops',
						  text: 'Please enter the date of this update',
						  type: 'error',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
			 		})
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities/post/add_compliance_update/'+this.shid+'/'+this.eid;
      		ApiService.post(uri, this.compliance_update).then(response => {
      	
         			 this.initPage();
         			 swal({
						  title: 'Done',
						  text: 'The compliance update has been added.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						})
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


